import { Mutation } from '@apollo/client/react/components';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { withSnackbar } from 'notistack';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { DELETE_DRAFT } from '../../../helpers/graphql/drafts';
import { red } from '@mui/material/colors';

const theme = createTheme({
  palette: {
    primary: red,
  },
});

class DeleteDraftButton extends Component {
  state = {
    open: false,
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

  newNotification(notification) {
    if (notification !== undefined) {
      let variant = 'success';
      if (notification.success === false) {
        variant = 'error';
      }
      const { enqueueSnackbar } = this.props;
      enqueueSnackbar(notification.message, { variant });
    }
  }

  render() {
    const { id, onDelete } = this.props;
    const { open } = this.state;
    return (
      <Mutation
        mutation={DELETE_DRAFT}
        variables={{
          id,
        }}
      >
        {(deleteDraft, data) => {
          if (data.data && data.data.deleteDraft && open) {
            this.handleClose();
            if (!data.data.deleteDraft.success) {
              this.newNotification({
                success: data.data.deleteDraft.success,
                message: data.data.deleteDraft.message,
              });
            }
            if (data.data.deleteDraft.success) {
              onDelete();
            }
          }
          return (
            <>
              <span className="text-light">
                <ThemeProvider theme={theme}>
                  <Button onClick={this.handleClickOpen} color="primary">
                    <DeleteIcon />
                    <span className="textPrimary pl-1">Delete</span>
                  </Button>
                </ThemeProvider>
              </span>
              <Dialog
                open={open}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">Delete Draft?</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    Are you sure that you want to delete this draft? Deleted
                    drafts cannot be restored.
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.handleClose} color="primary" autoFocus>
                    Cancel
                  </Button>
                  <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={theme}>
                      <Button
                        variant="contained"
                        onClick={deleteDraft}
                        color="primary"
                      >
                        <DeleteForeverIcon /> Delete
                      </Button>
                    </ThemeProvider>
                  </StyledEngineProvider>
                </DialogActions>
              </Dialog>
            </>
          );
        }}
      </Mutation>
    );
  }
}

DeleteDraftButton.propTypes = {
  id: PropTypes.string.isRequired,
  enqueueSnackbar: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default withSnackbar(DeleteDraftButton);
